// extracted by mini-css-extract-plugin
module.exports = {"ad":"ad-3IOk6nj8"};